import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { stylePublicVac } from "./style-public-vacancie";
import { headers } from "./headers";
import { withStyles } from "@material-ui/styles";
import * as IdKey from "short-uuid";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";


const tablePublicVacancies = ({
  data,
  handleClickClose,
  handleClickOpenModal,
  contractTypes
}) => {
  const classes = stylePublicVac();
  const id = IdKey.generate();
  const addDots = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        if (header.field === "salary") {
          return object[header.field] === 0
            ? "A convenir"
            : object[header.field]
            ? "$ " + addDots(object[header.field])
            : "";
        }
        if (header.field === "contractType") {
          let clave = object[header.field]?.toUpperCase();
          let valor = contractTypes.find(
            (contrato) => contrato.contractTypes === clave
          );
          return valor ? valor.contractTypeDescription
          : "";
        }
        return object[header.field];
      }
      return "";
    }
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  return (
    <div className={classes.divAccordion}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header?.title}
              </Typography>
              <Typography
                className={classes.secondaryHeading}
                style={{ flexBasis: "auto", wordBreak: "normal" }}
              >
                {header.isRequisition
                  ? getValueByKey(data.requisition, header)
                  : getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnBtn}>
          <Tooltip title="Ver detalle" arrow placement="top">
              <VisibilityIcon className={classes.iconEvent} />
            </Tooltip>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              variant="contained"
              className={classes.buttonSearch}
              onClick={handleClickOpenModal}
            >
              Aplicar
            </Button>
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <Grid container spacing={3}>
                <Grid item xs={12} style={{marginTop:"8px"}}>
                  <Typography className={classes.heading}>
                    OBSERVACIONES
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {data.observation}
                  </Typography>
                </Grid>

            </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default tablePublicVacancies;
